import React from "react"

function Menu({ menu, showHome = false, isMobile = false, setHamburgerOpen }) {

  return (
    <ul className={`${!isMobile ? 'navbar-nav mb-2 mb-lg-0' : ''}`}>
      {
        
        menu
          .filter(menuItem => {
            const label = (menuItem.label || '').toLowerCase();
            const path = (menuItem.path || '').toLowerCase();
            return !label.includes('leaderboard') && !path.includes('leaderboard');
          })
        .map(menuItem => {
          if (showHome) {
            return (<MenuItem menuItem={menuItem} key={menuItem.databaseId} setHamburgerOpen={setHamburgerOpen} isMobile={isMobile} />)
          } else {
            return (
              menuItem.path === "/" ? "" : <MenuItem menuItem={menuItem} key={menuItem.databaseId} setHamburgerOpen={setHamburgerOpen} isMobile={isMobile} />
            )
          }
        })}

        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            Leaderboard
          </a>
          <div className="dropdown-menu" aria-labelledby="navbarDropdown">
            <a className="dropdown-item" href="/krill-leaderboard">Leaderboard</a>
            <a className="dropdown-item" href="/bsop-leaderboard-2025">BSOP Leaderboard</a>
          </div>
        </li>


        <li className="nav-item">
            <a className="nav-link" href={'/bitcoin-crypto-poker-freerolls'}>Hourly Freerolls</a>
        </li>

        <li className="nav-item">
            <a className="nav-link" href={'/affiliates'} onClick={() => {
              if(isMobile) {
              setHamburgerOpen((prev) => !prev);
              document.body.classList.remove('overflow');
            }
        }}>Promote & Earn</a>
        </li>
    </ul>
  )
}

const MenuItem = ({ menuItem, setHamburgerOpen, isMobile }) => (

  <li className="nav-item">
    {isMobile ?
      <a className="nav-link" href={menuItem.path} onClick={() => {
        setHamburgerOpen((prev) => !prev);
        document.body.classList.remove('overflow');
      }} >{menuItem.label}</a>
      :
      <a className="nav-link" href={menuItem.path} >{menuItem.label}</a>
    }
  </li>
)

export default Menu